export const updateAgentLedDataReducer = {
  updateAgentLedData: (state, action) => {
    state.isAgentLedJourney = action.payload.isAgentLedJourney;
    state.agentLedJourneyCustomerData = {
      ...state.agentLedJourneyCustomerData,
      ...action.payload,
    };
  },
};
